import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';

import { useAuth } from '../store/AuthContext';
import Sidebar from './Sidebar';
import logo from '../AzOtteMCRM.svg';

export default function Layout() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="layout">
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
      />

      <div className="mobile-topbar">
        <button className="hamburger" onClick={() => setMobileOpen(!mobileOpen)}>
          <MenuOutlinedIcon fontSize="small" />
        </button>
        <img
          src={logo}
          alt="Azotte MCRM"
          style={{ height: 28 }}
          onClick={() => navigate('/')}
        />
        <span className="mobile-topbar-user">{user?.fullName || user?.username}</span>
      </div>

      <main className={`main-content${collapsed ? ' sidebar-collapsed' : ''}`}>
        <Outlet />
      </main>
    </div>
  );
}
